import * as yup from 'yup';

const codNcmSchema = yup.lazy((v) => {
  // aceita number (ex: 12345678)
  if (typeof v === 'number') {
    return yup.number().required();
  }

  // aceita objeto (ex: { label: "xxx", value: 12345678 })
  return yup
    .object({
      label: yup.string().notRequired(),
      value: yup.number().required(),
    })
    .required();
});

export const schema = yup
  .object({
    des_produto: yup.string().trim().required(),
    cod_departamento: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_ncm: codNcmSchema,
    val_peso: yup.string().required(),
    cod_id_ctb: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_tipo_item: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();

export const schemaDerivado = yup
  .object({
    des_produto: yup.string().trim().required(),
    cod_departamento: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    cod_tipo_ajuste: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
    des_unidade: yup.object().shape({
      label: yup.string().required(),
      value: yup.string().required(),
    }),
  })
  .required();
